import { render, staticRenderFns } from "./ReviewsComponent.vue?vue&type=template&id=d4cb279e"
import script from "./ReviewsComponent.vue?vue&type=script&lang=js"
export * from "./ReviewsComponent.vue?vue&type=script&lang=js"
import style0 from "./ReviewsComponent.vue?vue&type=style&index=0&id=d4cb279e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports